import api from '../services/api';
import { ITaxe } from '../shared/interfaces';

interface IResponseGetTaxes {
  data: ITaxe[];
  count: number;
  payment_method_description: string;
}
export const getTaxes = async (
  take: number,
  payment_method_id: string | undefined,
  skip: number,
  keyword?: string,
): Promise<IResponseGetTaxes> => {
  const response = await api.post('/taxes/list', {
    take,
    payment_method_id,
    skip,
    keyword,
  });
  return response.data;
};

export const postTaxe = async (payload: any): Promise<ITaxe> => {
  const response = await api.post(`/taxes`, payload);
  return response.data;
};

export const patchTaxe = async (
  id: string | undefined,
  payload: any,
): Promise<ITaxe> => {
  if (!id) {
    throw new Error('ID da taxa não fornecido.');
  }
  const response = await api.patch(`/taxes/${id}`, payload);
  return response.data;
};
